import http from './public'
const basePath = 'https://admin.zhonghaiyy.com'
// 发送登录验证码
export const userSendLoginMessage = (params) => {
  return http.fetchPost(`${basePath}/api/Member/SendLoginMessage`, params)
}
// 手机号登录
export const userLogin = (params) => {
  return http.fetchPost(`${basePath}/api/Member/Login`, params)
}
export const userLoginPassword = (params) => {
  return http.fetchPost(`${basePath}/api/Member/AcountLogin`, params)
}
// 手机号注册
export const userRegist = (params) => {
  return http.fetchPost(`${basePath}/api/Member/Regist`, params)
}
// 发送注册验证码
export const userSendRegistLoginMessage = (params) => {
  return http.fetchPost(`${basePath}/api/Member/SendRegistLoginMessage`, params)
}
// 刷新token
export const userRefreshToken = (params) => {
  return http.fetchPost(`${basePath}/api/Member/RefreshToken`, params)
}
// 获取用户详情
export const userDetail = (params, header) => {
  return http.fetchPost(`${basePath}/api/Member/Get`, params, header)
}
// 更改用户详情
export const userEditDetail = (params) => {
  return http.fetchPost(`${basePath}/api/Member/Edit`, params)
}
// 获取当前登录的用户信息
export const userInfoDetail = (params) => {
  return http.fetchPost(`${basePath}/api/Member/GetLoginInfo`, params)
}
// 获取首页药品推荐列表
export const medicineRecommendList = (params) => {
  return http.fetchPost(`${basePath}/api/MedicineRecommend/GetList`, params)
}
// 获取首页讲座列表
export const lectureList = (params) => {
  return http.fetchPost(`${basePath}/api/Lecture/IndexSearch`, params)
}
// 获取首页banner列表
export const bannerList = (params,header) => {
  return http.fetchPost(`${basePath}/api/IndexImages/Search`, params,header)
}
// 获取首页新闻列表
export const newsList = (params) => {
  return http.fetchPost(`${basePath}/api/Article/IndexSearch`, params)
}
// 获取药品库的药品分类
export const getAllClass = (params) => {
  return http.fetchPost(`${basePath}/api/MedicineLibrary/AllClass`, params)
}
// 获取药品库的药品搜索
export const searchMed = (params) => {
  return http.fetchPost(`${basePath}/api/MedicineLibrary/GetMedicineListWithClassId`, params)
}
// 获取推荐药品
export const getRecomendMedicine = (params) => {
  return http.fetchPost(`${basePath}/api/MedicineLibrary/GetRecomendMedicine`, params)
}
// 获取药品详情
export const getMedicineInfo = (params, header) => {
  return http.fetchPost(`${basePath}/api/MedicineLibrary/GetMedicineInfo`, params, header)
}
// 获取药品相关药品
export const getRelatedMedicine = (params, header) => {
  return http.fetchPost(`${basePath}/api/MedicineLibrary/RelatedMedicine`, params, header)
}
// 预定药品
export const preOrder = (params) => {
  return http.fetchPost(`${basePath}/api/PreOrder/Order`, params)
}
// 上传头像
export const uploadImage = (params, header) => {
  return http.fetchPost(`${basePath}/api/_file/UploadImage`, params, header)
}
// 收藏的讲座列表
export const lectureFavorite = (params) => {
  return http.fetchPost(`${basePath}/api/LectureFavorite/Search`, params)
}
// 我的讲座列表
export const myLecturelist = (params) => {
  return http.fetchPost(`${basePath}/api/Lecture/Search`, params)
}
// 我的评论
export const myReviewList = (params) => {
  return http.fetchPost(`${basePath}/api/LectureReviewss/MyReviewList`, params)
}
// 关注的讲师列表
export const myFavoriteList = (params) => {
  return http.fetchPost(`${basePath}/api/LecturerAttention/Search`, params)
}
// 我的预定
export const myOrderList = (params) => {
  return http.fetchPost(`${basePath}/api/PreOrder/PreOrderList`, params)
}
// 取消预定
export const quitOrder = (params, header) => {
  return http.fetchPost(`${basePath}/api/PreOrder/QuitOrder`, params, header)
}
// 新闻列表
export const getAllNewsList = (params) => {
  return http.fetchPost(`${basePath}/api/Article/RecommendSearch`, params)
}
// 新闻详情
export const newsDetail = (params, header) => {
  return http.fetchPost(`${basePath}/api/Article/GetInfo`, params, header)
}
// 文章列表
export const recommendSearch = (params) => {
  return http.fetchPost(`${basePath}/api/Article/Search`, params)
}

// 首页药品分类
export const getIndexPicClass = (params) => {
  return http.fetchPost(`${basePath}/api/MedicineLibrary/IndexPicClass`, params)
}
// 新闻详情推荐
export const getRandSearch = (params) => {
  return http.fetchPost(`${basePath}/api/Article/RandSearch`, params)
}
// 行业列表
export const getPolicyList = (params) => {
  return http.fetchPost(`${basePath}/api/Policy/IndexSearch`, params)
}
// 行业详情
export const getPolicyInfo = (params, header) => {
  return http.fetchPost(`${basePath}/api/Policy/Info`, params, header)
}




// WEBPACK FOOTER //
// ./src/api/index.js